<template>
	<CommonLoading
		v-if="loading"
	/>
	<FilterComponent
		:title="'Agendamentos'"
		:open="openFilter"
		:fields="filterFields"
		@apply-filters="handleFilters"
		@update-open="openFilter = false"
    />
	<CustomListing
		:search= "false"
		:listingData = "data"
		:headersData = "headers"
		:headerInfo = "headerInfo"
		:previous = "previous"
		:next = "next"
		:currentPage = "currentPage"
		:totalPages = "totalPages"
		:totalRecords = "totalRecords"
		:customActions = "[{ name: 'visualizar' }]"
		:useDefaultActions= "false"
        :defaultButtons= "false"
		:useForms= "false"
		:useView= "false"
		:inputsList="inputs"
        @custom-button="handleCustomButton"
		@previous-page= "pageData"
		@next-page= "pageData"
		@go-to-page= "goTo"
		@filter="openFilter = true"
	/>

</template>
<script>
import CustomListing from '@/components/generalcomponents/CustomListing';
import AgendamentosRepository from '@/services/AgendamentosRepository.vue';
import { pageVariables } from '@/views/insideviews/agendamentos/PageVariablesAgendamentos';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import EmpresasRepository from '@/services/EmpresasRepository.vue';
import SeguradosRepository from '@/services/SeguradosRepository.vue';
import Swal from "sweetalert2";
import CommonLoading from '@/components/generalcomponents/CommonLoading.vue';
import FilterComponent from "@/components/generalcomponents/CommonFilter.vue";

export default {
	name: 'ListaDeAgendamentosRotaView',
	async created(){
		this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
		this.pageData(this.getAgendamentosPage);
	},
	data() {
		return {
			...pageVariables,
			data: [],
			previous: '',
			next: '',
			totalPages: 0,
			totalRecords: 0,
			currentPage: 0,
			resetFormData: false,
			editFormData:{},
			formOpen : false,
			empresas: [],
			count: null,
			viewOpen: false,
			agendamentoData:{},
			onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
			loading: false,
			editOpen: false,
			openFilter: false,
			filters: [],
			filterFields: [
				{
					name: "nome",
					label: "Nome",
					type: "input",
					placeholder: "Digite o nome"
				}
			]
		};
	},
	props: {
	},
	methods: {
		async pageData(page){
			this.loading = true; 
			const agendamentosRepo = new AgendamentosRepository();
			try {
				const response = await agendamentosRepo.getAgendamentos(this.onlineUser.token,page,this.filters);
				if (response?.status  === 200) {
					this.data = response.data.data;
					this.totalPages = response.data.last_page;
					this.totalRecords = response.data.total;
					this.currentPage = response.data.current_page;
					this.getAgendadores();
					this.getEmpresas();

				if (response.data.next_page_url) {
					this.next = response.data.next_page_url;
				}else{
					this.next = ""
				}
				if (response.data.prev_page_url) {
					this.previous = response.data.prev_page_url;
				}else{
					this.previous = ""
				}
				this.loading = false; 

				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error); 
			}
		},
		
		async getEmpresas() {
			const empresasRepo = new EmpresasRepository();
			try {
				const response = await empresasRepo.getEmpresasSelect(this.onlineUser.token, this.empresasSelectpage);
				if (response?.status === 200) {
					// Ordena os dados em ordem alfabética pelo nome (ajuste para a propriedade correta, se necessário)
					this.empresas = response.data.sort((a, b) => {
						const nameA = a.nome.toLowerCase(); // Troque "nome" pela propriedade correta
						const nameB = b.nome.toLowerCase();
						return nameA.localeCompare(nameB); // Comparação alfabética
					});
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
			}
		},
		async getFilterCount(data){
			this.loading = true;
			const seguradoRepo = new SeguradosRepository();
			try {
				console.log(data)
				const response = await seguradoRepo.FilterSegurado(this.seguradosFilterPage,data,this.onlineUser.token);
				if (response?.status === 200) {
					this.loading = false;
					this.openFilter = false;
					this.count = response.data.count
					console.log(response.data)
				} else {
					this.loading = false;
					this.error = response?.message;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
			}	
		},
		
		goTo(number){
			this.pageData(this.getAgendamentosPage+"?page="+number)
		},
		resetForm() {
			this.resetFormData = true;
			this.$nextTick(() => {
				this.resetFormData = false;
			});
		},
		handleFilters(rawFilters){
			console.log(rawFilters)
			this.filters = rawFilters
			this.openFilter = false;
			this.pageData(this.getAgendamentosPage);
		},
		mostrarAlerta() {
			Swal.fire({
				icon: 'success',
				title: 'Sucesso!',
				text: 'A operação foi concluída com sucesso.',
				confirmButtonColor: '#3085d6',
			});
		},
        handleCustomButton(data) {
            switch (data.eventName) {
            case 'visualizar':
                this.$router.push({
                    name: 'listaAgendamentos',
                    query: { id: data.id }
                });
                break;
            default:
                console.warn('Ação desconhecida:', data.eventName);
            }
        }
	},
	components:{
		CustomListing,
		CommonLoading,
		FilterComponent
	},
	setup() {
	return {
	}
	}}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
